(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const visual = document.querySelector('.pageHeader__visual');
  if (visual) {
    const handleScroll = () => {
      const visualBottom = visual.getBoundingClientRect().bottom;
      document.body.toggleAttribute('data-scrolled', visualBottom <= 150);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('.header__toggleButton');

    if (!toggleButton) return;

    const header = document.querySelector('.header');
    if (!header) return;

    header.classList.toggle('--open');
  });

  } catch(e) { console.error(e); }
})();
})();
